import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import DownArrow from '@/assets/SpectrotelIcons/DownArrow.svg'
import { useTheme } from '@/hooks/contexts/themeContext'
import { useState, useEffect } from 'react'
import {
  AccessibilityIcon,
  DarkThemeSwitchIcon,
  // HighContrast,
  LightThemeSwitchIcon,
} from '@/assets/icons'
import { useAppDispatch, useAppSelector } from '@/hooks/storeHooks/storehooks'
import {
  setFontChangePx,
  setValue,
} from '@/redux-store/slices/menuItemSlice/menuItemSlice'
import CustomSwitch from '@/components/atom/SwitchCmp/customSwitch'
// import { FontSizeIcon } from '@radix-ui/react-icons'
import { useAuth0 } from '@auth0/auth0-react'
import { getUserFontSize } from '@/lib/userPreferences'

export function AccessibilityMenu() {
  const { setTheme } = useTheme()
  const dispatch = useAppDispatch()
  const themeValue = useAppSelector(state => state.menu.value)
  const { user } = useAuth0()

  const [isChecked, setIsChecked] = useState(
    themeValue === 'dark' || themeValue === 'high-contrast-dark' ? true : false,
  )
  // const [contrast, setContrast] = useState(themeValue.includes('high-contrast'))
  // const [fontSize, setFontSize] = useState(0)

  useEffect(() => {
    if (user?.sub) {
      const savedFontSize = getUserFontSize(user.sub)
      // setFontSize(savedFontSize)
      dispatch(setFontChangePx(savedFontSize))
    }
  }, [user?.sub, dispatch])

  const handleCheckedChange = (checked: boolean) => {
    setIsChecked(checked)
    if (setTheme) {
      if (checked) {
        setTheme('dark')
        dispatch(setValue('dark'))
      } else {
        setTheme('light')
        dispatch(setValue('light'))
      }
    }
  }

  // const handleCheckedChange = (checked: boolean) => {
  //   setIsChecked(checked)
  //   if (setTheme) {
  //     if (checked) {
  //       setTheme(contrast ? 'high-contrast-dark' : 'dark')
  //       dispatch(setValue(contrast ? 'high-contrast-dark' : 'dark'))
  //     } else {
  //       setTheme(contrast ? 'high-contrast-light' : 'light')
  //       dispatch(setValue(contrast ? 'high-contrast-light' : 'light'))
  //     }
  //   }
  // }

  // const handleContrastChange = (checked: boolean) => {
  //   setContrast(checked)
  //   if (setTheme) {
  //     if (checked) {
  //       setTheme(isChecked ? 'high-contrast-dark' : 'high-contrast-light')
  //       dispatch(
  //         setValue(isChecked ? 'high-contrast-dark' : 'high-contrast-light'),
  //       )
  //     } else {
  //       setTheme(isChecked ? 'dark' : 'light')
  //       dispatch(setValue(isChecked ? 'dark' : 'light'))
  //     }
  //   }
  // }

  // const handleFontSizeChange = (size: number) => {
  //   setFontSize(size)
  //   dispatch(setFontChangePx(size))

  //   if (user?.sub) {
  //     setUserFontSize(user.sub, size)
  //   }
  // }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div
          id='accessibility_menu'
          className='bg-tertiary gap-2 p-2 flex justify-center items-center rounded-radius-md flex-shrink-0 cursor-pointer hover:scale-110 transition-transform'
        >
          <AccessibilityIcon />
          <img
            src={DownArrow}
            alt='down arrow'
            className='h-2 w-2 dark:invert'
          />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent className='w-[15.0625rem] rounded-radius-md mt-6 mr-16 bg-primary  bg-clip-padding border-4  border-border-opacity text-primary-foreground shadow-[0_4px_4px_rgba(129,129,129,0.25)]'>
        <DropdownMenuGroup>
          <DropdownMenuItem
            onSelect={e => e.preventDefault()}
            className='flex-row mt-2 hover:bg-primary-hover rounded-radius-sm'
          >
            <div className='flex flex-row gap-2 items-center'>
              <LightThemeSwitchIcon />
              <h1 className='text-primary-foreground '>Theme</h1>
            </div>
            <DropdownMenuShortcut>
              <CustomSwitch
                onIcon={<DarkThemeSwitchIcon />}
                offIcon={<LightThemeSwitchIcon />}
                onChange={handleCheckedChange}
                checked={isChecked}
              />
            </DropdownMenuShortcut>
          </DropdownMenuItem>
          {/* <DropdownMenuItem
            onSelect={e => e.preventDefault()}
            className='flex flex-row items-center justify-between mt-2 hover:bg-primary-hover rounded-radius-sm px-2'
          >
            <div className='flex flex-row gap-2 items-center'>
              <FontSizeIcon />
              <h1 className='text-primary-foreground'>Font Size</h1>
            </div>
            <div className='flex flex-row gap-2'>
              {[0, 2, 4].map(size => (
                <button
                  key={size}
                  className={`w-10 h-10 rounded-full flex border border-secondary items-center justify-center transition-colors ${
                    fontSize === size
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-secondary-border text-primary-foreground'
                  }`}
                  onClick={() => handleFontSizeChange(size)}
                >
                  <span
                    className={`${
                      size === 0
                        ? 'text-base'
                        : size === 2
                          ? 'text-lg'
                          : 'text-2xl'
                    } font-normal`}
                  >
                    A
                  </span>
                </button>
              ))}
            </div>
          </DropdownMenuItem> */}

          {/* <DropdownMenuItem
            onSelect={e => e.preventDefault()}
            className='flex-row mt-2 hover:bg-primary-hover rounded-radius-sm'
          >
            <div className='flex flex-row gap-2 items-center'>
              <HighContrast />
              <h1 className='text-primary-foreground '>High Contrast</h1>
            </div>
            <DropdownMenuShortcut>
              <CustomSwitch
                onChange={handleContrastChange}
                checked={contrast}
              />
            </DropdownMenuShortcut>
          </DropdownMenuItem> */}
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
